window.theme = window.theme || {};

window.theme.sizes = {
  mobile: 480,
  small: 750,
  large: 990,
  widescreen: 1400,
};

window.theme.keyboardKeys = {
  TAB: 9,
  ENTER: 13,
  ESCAPE: 27,
  SPACE: 32,
  LEFTARROW: 37,
  RIGHTARROW: 39,
};

window.theme.focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
